import React from 'react';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import LoginRoundedIcon from '@mui/icons-material/LoginRounded';
import ContentPasteRoundedIcon from '@mui/icons-material/ContentPasteRounded';
import PeopleOutlineRoundedIcon from '@mui/icons-material/PeopleOutlineRounded';
import TodayRoundedIcon from '@mui/icons-material/TodayRounded';
import AdminPanelSettingsRoundedIcon from '@mui/icons-material/AdminPanelSettingsRounded';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import ViewCarouselIcon from '@mui/icons-material/ViewCarousel';
import FeaturedVideoIcon from '@mui/icons-material/FeaturedVideo';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import LocalCafeIcon from '@mui/icons-material/LocalCafe';
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import ImageIcon from '@mui/icons-material/Image';

export const SidebarData = [
  {
    title: "Dashboard",
    icon: <HomeRoundedIcon />,
    link: "/"
  },
  // {
  //   title: "Orders",
  //   icon: <ContentPasteRoundedIcon />,
  //   link: "/orders"
  // },
  // {
  //   title: "Clients",
  //   icon: <PeopleOutlineRoundedIcon />,
  //   link: "/clients"
  // },
  // {
  //   title: "Calendar",
  //   icon: <TodayRoundedIcon />,
  //   link: "/calendar"
  // },
  {
    title : "Guest",
    icon : <EmojiPeopleIcon />,
    link : "/guest"
  },
  {
    title : "Banner",
    icon : <ViewCarouselIcon />,
    link : "/banners"
  },
  {
    title : "Ads",
    icon : <FeaturedVideoIcon />,
    link : "/ads"
  },
  {
    title : "Categories",
    icon : <LocalCafeIcon />,
    link : "/drink-categories"
  },
  {
    title : "Menu",
    icon : <RestaurantMenuIcon />,
    link : "/drink-menu"
  },
  {
    title : "Home Banners",
    icon : <ImageIcon />,
    link : "/home-banners"
  },
  {
    title : "Vouchers",
    icon : <QrCode2Icon />,
    link : "/voucher"
  },
  {
    title : "Discount",
    icon : <LocalOfferIcon />,
    link : "/discounts"
  },
  {
    title: "Admin pannel",
    icon: <AdminPanelSettingsRoundedIcon />,
    link: "/adminPannel",
    role: "admin"
  }
];
